import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { BrandFormWrapperComponent } from '../components/brand-form-wrapper/brand-form-wrapper.component';
import {
  BrandFormConfig,
  BRAND_HEADER_ACTIONS,
  createBrandFormFields,
} from '../brand.config';

@Component({
  selector: 'app-brand-add',
  standalone: true,
  imports: [BrandFormWrapperComponent],
  templateUrl: './brand-add.component.html',
  styleUrls: ['./brand-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: BrandFormWrapperComponent;

  config: BrandFormConfig = {
    title: 'brand.form.add.title',
    formFields: createBrandFormFields(),
    headerActions: BRAND_HEADER_ACTIONS,
    listRoute: '/goods/brand',
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
